import { render, staticRenderFns } from "./form-row-edit-checkbox.vue?vue&type=template&id=22e4645b&scoped=true&"
import script from "./form-row-edit-checkbox.vue?vue&type=script&lang=js&"
export * from "./form-row-edit-checkbox.vue?vue&type=script&lang=js&"
import style0 from "./form-row-edit-checkbox.vue?vue&type=style&index=0&id=22e4645b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e4645b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22e4645b')) {
      api.createRecord('22e4645b', component.options)
    } else {
      api.reload('22e4645b', component.options)
    }
    module.hot.accept("./form-row-edit-checkbox.vue?vue&type=template&id=22e4645b&scoped=true&", function () {
      api.rerender('22e4645b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/form-rows/form-row-edit-checkbox.vue"
export default component.exports